import {
    setHigherOrderMatrix} from 'actions/index.js';
import HigherOrderStepData from "higherorder/HigherOrderStepData.js";
import {mod} from 'utils/mod.js';

export default superclass => class extends superclass {
    getSelection({x1, y1, x2, y2}) {
        return this.steps
            .filter(
                ({x,y}) =>
                    x1 <= x && x <= x2 &&
                    y1 <= y && y <= y2);
    }

    setStepSize(x,y,size) {
        if (!this.matrix[x][y]) {
            return;
        }
        this.matrix[x][y].size = size;
        this.updateRedux();
    }

    moveStepTo(x1, y1, x2, y2) {
        if (!this.matrix[x1]) {
            return;
        }
        let step = this.matrix[x1][y1];
        if (!step) {
            return;
        }
        x2 = mod(x2, this.matrix.length - step.size + 1);
        y2 = mod(y2, this.matrix[0].length - step.size + 1);
        this.matrix[x1][y1] = 0;

        if (this.matrix[x2][y2]) {
            this.deleteSteps([this.matrix[x2][y2]]);
        }
        this.matrix[x2][y2] = step;
        step.x = x2;
        step.y = y2;
        this.updateRedux();
    }
    
    noIntersect(x,y) {
        return true;
    }

    newStep(x,y, size=1,orientation=0) {
        this.matrix = [... this.matrix];
        if (this.matrix[x][y]) {
            this.deleteSteps([this.matrix[x][y]]);
        }
        let step = new HigherOrderStepData();
        this.matrix[x][y] = step;
        step.x = x;
        step.y = y;
        step.size = size;
        step.orientation = orientation;
        this.steps.push(step);
        return step;
    }

    toggle(x,y) {
        this.matrix = [... this.matrix];
        if (this.matrix[x][y]) {
            this.matrix[x][y].orientation = this.matrix[x][y].orientation === 0 ?
                1 : 0;
        } else if (this.noIntersect(x,y)) {
            this.matrix[x][y] = new HigherOrderStepData();
            this.matrix[x][y].x=x;
            this.matrix[x][y].y=y;
            this.steps.push(this.matrix[x][y]);
        }
        this.updateRedux(x);
    }

    deleteSteps(steps) {
        for (let i=0; i < this.matrix.length; i++ ){
            for (let j=0; j < this.matrix[i].length; j++) {
                if (steps.includes(this.matrix[i][j])) {
                    this.matrix[i][j] = 0;
                }
            }
        }
        this.steps = this.steps.filter(
            x => !steps.includes(x));
        this.updateRedux();
    }

    updateRedux(x) {
        this.computeShapes();
        if (x !== undefined) {
            this.matrix[x] = [... this.matrix[x]];
        }
        this.sequencerEngine.dispatch(
            setHigherOrderMatrix([... this.matrix]));
    }
}

